<template>
  <div class="main-body">

    <div class="header">智能手表</div>

    <div class="out" style="background-color: #fff;margin: 10px">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="机构护士" name="nurse">
          <PartNurse ref="myPartNurse"></PartNurse>
        </el-tab-pane>
        <el-tab-pane label="老人" name="user">
          <PartUser ref="myPartUser"></PartUser>
        </el-tab-pane>

      </el-tabs>
    </div>

  </div>
</template>

<script>

import PartUser from "./PageUserIns";
import PartNurse from "./PageNurseIns";

export default {
  name: 'ElderlyInsCheckIn',
  data() {
    return {

      loading: false,

      activeName: '',


    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th=val
    },
  },
  components:{
    PartUser,PartNurse
  },
  mounted() {
    this.init();
  },
  created() {
    this.th = this.$store.state.tableHeight;

  },
  methods: {
    init(){

      this.activeName = 'nurse';
      this.$refs.myPartNurse.init();

    },

    handleClick(tab, event) {
      //console.log(tab, event);
      //console.log(tab.name);

      if(tab.name == 'user'){
        this.$refs.myPartUser.init();
      }
      if(tab.name == 'nurse'){
        this.$refs.myPartNurse.init();
      }

    },


  }
}


</script>

<style lang="scss" scoped>

</style>
